export default "__VITE_ASSET__9ms7fM4o__"